<template>
    <mu-flat-button label="图标按钮" icon="insert_emoticon" style="transform:scale(1.2)">
    </mu-flat-button>
</template>
<script>
export default {
    name: 'IconButton'
}
</script>



// WEBPACK FOOTER //
// iconButton.vue?f78c3a16